/* Risk test contact form: confirmation shown as a modal */

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

function visibleFocusable(container) {
  return Array.prototype.slice
    .call(container.querySelectorAll(FOCUSABLE))
    .filter((element) => element.offsetParent !== null);
}

/**
 * Remove ids from the copy so the page does not end up with duplicate ids.
 */
function stripIds(element) {
  element.removeAttribute('id');
  Array.prototype.forEach.call(element.querySelectorAll('[id]'), (child) => {
    child.removeAttribute('id');
  });
}

function setupRiskTestModal(wrapper) {
  const formId = wrapper.getAttribute('data-form-id');
  const modal = wrapper.querySelector('.risk-test-modal');

  if (!formId || !modal) return;

  const body = modal.querySelector('.risk-test-modal__body');
  const closeButton = modal.querySelector('.risk-test-modal__close');
  const toggle = wrapper.querySelector('.accordion-item__header');
  const panel = wrapper.querySelector('.accordion-item__panel');

  if (!body || !closeButton) return;

  let lastFocused = null;

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = visibleFocusable(modal);

    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /**
   * Close the accordion so the same confirmation is not shown both in the
   * modal and behind it. The state is kept compatible with the accordion
   * script, i.e. the toggle opens the form again.
   */
  function collapseAccordion() {
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    if (panel) {
      panel.style.maxHeight = null;
      panel.hidden = true;
    }
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    closeButton.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);

    // The submit button has been replaced by the confirmation, so focus is
    // returned to the accordion toggle when the original element is gone.
    const target =
      lastFocused && document.body.contains(lastFocused) ? lastFocused : toggle;

    if (target) target.focus();
  }

  closeButton.addEventListener('click', closeModal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  // Gravity Forms triggers this jQuery event once the confirmation of an ajax
  // submission has been rendered in place of the form.
  jQuery(document).on('gform_confirmation_loaded', (event, loadedFormId) => {
    if (String(loadedFormId) !== String(formId)) return;

    // Look inside this accordion only: the page also has the risk test's own
    // confirmation, which contains the whole accordion.
    const confirmation = wrapper.querySelector('.gform_confirmation_wrapper');

    if (!confirmation) return;

    const copy = confirmation.cloneNode(true);
    stripIds(copy);

    body.innerHTML = '';
    body.appendChild(copy);

    collapseAccordion();
    openModal();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  Array.prototype.forEach.call(
    document.querySelectorAll('.risk-test-contact[data-form-id]'),
    setupRiskTestModal
  );
});
